import React from 'react';
import { Box } from '@material-ui/core';
import { InviteUser, InviteUserLink, UserList } from 'modules/multi-user';
import { useBusinessMembers } from 'hooks/business/use-business-members';
import { useTracking, TrackPageName } from 'modules/tracking';
import { FeatureFlag, FeatureFlags } from 'utils/feature-flags';
import { UserRole } from 'modules/2023-q4/rbac/enums/user-role';
import { UserPermissionsRequired } from 'modules/2023-q4/rbac/components/user-permissions-required/user-permissions-required';
import { DualApprovalToggle } from './dual-approval-toggle';

export const Team: React.FC = () => {
  useTracking<{
    page: TrackPageName;
  }>({
    page: TrackPageName.SettingsTeam,
  });

  const { data: businessMembers } = useBusinessMembers();

  const inviteUserLink = (
    <Box mb={10}>
      <InviteUserLink />
    </Box>
  );

  const inviteSection =
    businessMembers?.length <= 1 ? (
      <FeatureFlag
        disabled={<InviteUser />}
        enabled={
          <UserPermissionsRequired roles={[UserRole.ADMIN]}>
            <InviteUser />
          </UserPermissionsRequired>
        }
        flag={FeatureFlags.REACT_APP_2023_Q4_USER_ROLES_ENABLED}
      />
    ) : (
      <>
        <FeatureFlag
          disabled={inviteUserLink}
          enabled={
            <UserPermissionsRequired roles={[UserRole.ADMIN]}>
              {inviteUserLink}
            </UserPermissionsRequired>
          }
          flag={FeatureFlags.REACT_APP_2023_Q4_USER_ROLES_ENABLED}
        />
        <UserList />
      </>
    );

  return (
    <>
      <DualApprovalToggle />
      {inviteSection}
    </>
  );
};
